exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fade-enter-active[data-v-80d028c2], .fade-leave-active[data-v-80d028c2] {\n    transition: opacity 0.2s;\n}\n.fade-enter[data-v-80d028c2], .fade-leave-to[data-v-80d028c2] {\n    opacity: 0;\n}\n", ""]);

// exports
